import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Link} from "react-router-dom";
import logoWhite from "../../assets/Images/logo-white.png";

const HeaderAccountsPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const navigate = useNavigate();
  const location = useLocation();
  const redirectPage =projectInfo?.projectConfig?.config?.INITIAL_PAGE
  return (
    <header className="accountsPageHeader">
      <div className="left">
        <div className="logoContainer">
          <Link to={redirectPage==="LOGIN"?"/login":"/home"}>
            <h1>
              {/* <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Logo" /> */}
              <img src={logoWhite} alt="Logo" />
            </h1>
          </Link>
        </div>
      </div>
      <div className="right">
        {location?.pathname === "/register" ? (
          <button onClick={() => navigate("/login")}>Log in</button>
        ) : (
          <button onClick={() => navigate("/register")}>Sign up for FREE</button>
        )}
      </div>
    </header>
  );
};

export default HeaderAccountsPage;
